import React from "react";
import {
  DemoResponsiveGrid,
  DemoWorkbenchCard,
  DemoWorkbenchCopy,
  DemoWorkbenchMetricCard,
  DemoWorkbenchPill,
  DemoWorkbenchStack,
  type DemoPillVariant,
} from "@csk/demo-ui";
import {
  CURRENT_REGIME_TRANSITION,
  deploymentsToBoundary,
  driftColor,
  regimeTransitionStatus,
  type RegimeTransitionStatus,
  worstRegimeDrift,
} from "./regime-transition-panel/regimeTransitionModel.js";

const STATUS_VARIANT: Record<RegimeTransitionStatus, DemoPillVariant> = {
  green: "success",
  yellow: "warning",
  red: "danger",
};

const RegimeTransitionPanel = (): React.JSX.Element => {
  const current = CURRENT_REGIME_TRANSITION;
  const worstDrift = worstRegimeDrift(current);
  const status = regimeTransitionStatus(current.margin);
  const timeToBoundary = deploymentsToBoundary(current);

  return (
    <DemoWorkbenchStack>
      <DemoWorkbenchCard
        compact
        title={`Current regime: ${current.regime}`}
        description={`Worst drift: ${worstDrift.axis} at ${worstDrift.rate.toFixed(4)} / deployment`}
        actions={
          <DemoWorkbenchPill variant={STATUS_VARIANT[status]} mono>
            margin {current.margin.toFixed(3)}
          </DemoWorkbenchPill>
        }
      >
        <DemoWorkbenchCopy size="xs" tone="muted">
          Time to boundary: ~{timeToBoundary.toFixed(0)} deployments
        </DemoWorkbenchCopy>
      </DemoWorkbenchCard>

      <DemoResponsiveGrid minColumnWidth={130} gap={8} className="mt-4">
        {current.drift.map((d, i) => (
          <DemoWorkbenchMetricCard
            key={i}
            label={d.axis}
            value={`${d.rate >= 0 ? "+" : ""}${d.rate.toFixed(3)}`}
            color={driftColor(d.rate)}
            sub="per deploy"
          />
        ))}
      </DemoResponsiveGrid>
    </DemoWorkbenchStack>
  );
};

export default RegimeTransitionPanel;
